import jsPDF from "jspdf";
import { drawProHeader, drawProFooter, getSettingsCached } from "./pdfHeader";

export async function generateExamOrderPDF(o) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const margin = 48;

  const settings = o._settings || (await getSettingsCached());
  const doctor = o._doctor || {
    name: o.doctor_name,
    specialty: o.doctor_specialty,
    license_number: o.doctor_license,
  };

  const docTitle = o.type === "lab" ? "PETICIÓN DE LABORATORIO" : "PETICIÓN DE IMAGEN MÉDICA";

  let y = await drawProHeader(doc, {
    docTitle, docSubtitle: "", settings, doctor,
  });
  y += 14;

  doc.setFontSize(10);
  doc.setTextColor(100, 116, 139);
  doc.text(`Código: ${o.code}`, margin, y);
  doc.text(new Date(o.created_at).toLocaleString(), W - margin, y, { align: "right" });
  y += 14;
  doc.text(`Verificación: ${o.verification_code || "-"}`, margin, y);
  if (o.valid_until) doc.text(`Válida hasta: ${o.valid_until}`, W - margin, y, { align: "right" });
  y += 18;

  doc.setDrawColor(226, 232, 240);
  doc.line(margin, y, W - margin, y); y += 18;

  // Patient block
  doc.setFillColor(248, 250, 252);
  doc.roundedRect(margin, y - 4, W - 2 * margin, 56, 6, 6, "F");
  doc.setFontSize(9);
  doc.setTextColor(100, 116, 139);
  doc.text("PACIENTE", margin + 12, y + 10);
  doc.setFontSize(12);
  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "bold");
  doc.text(o.patient_name || "-", margin + 12, y + 26);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(71, 85, 105);
  if (o.patient_nif) doc.text(`DNI/NIE: ${o.patient_nif}`, margin + 12, y + 42);
  const urgLabel = ({ routine: "Rutina", preferent: "Preferente", urgent: "Urgente" })[o.urgency] || o.urgency;
  doc.text(`Prioridad: ${urgLabel}`, W - margin - 12, y + 42, { align: "right" });
  y += 70;

  if (o.clinical_info) {
    doc.setFontSize(11);
    doc.setTextColor(15, 118, 110);
    doc.setFont("helvetica", "bold");
    doc.text("INFORMACIÓN CLÍNICA", margin, y);
    doc.setFont("helvetica", "normal");
    y += 14;
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    const wrap = doc.splitTextToSize(o.clinical_info, W - 2 * margin);
    doc.text(wrap, margin, y); y += wrap.length * 14 + 12;
  }

  doc.setFontSize(11);
  doc.setTextColor(15, 118, 110);
  doc.setFont("helvetica", "bold");
  doc.text("PRUEBAS SOLICITADAS", margin, y);
  doc.setFont("helvetica", "normal");
  y += 16;
  (o.tests || []).forEach((tt, i) => {
    if (y > 660) { doc.addPage(); y = 60; }
    doc.setFillColor(255, 255, 255);
    doc.setDrawColor(226, 232, 240);
    doc.roundedRect(margin, y - 4, W - 2 * margin, tt.notes ? 42 : 28, 4, 4, "S");
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    doc.setFont("helvetica", "bold");
    doc.text(`${i + 1}. ${tt.name}`, margin + 10, y + 12);
    doc.setFont("helvetica", "normal");
    if (tt.notes) {
      doc.setFontSize(9);
      doc.setTextColor(100, 116, 139);
      const w2 = doc.splitTextToSize(tt.notes, W - 2 * margin - 16);
      doc.text(w2, margin + 10, y + 26); y += 42 + w2.length * 9;
    } else {
      y += 32;
    }
  });

  if (o.notes) {
    if (y > 640) { doc.addPage(); y = 60; }
    y += 6;
    doc.setFontSize(11);
    doc.setTextColor(15, 118, 110);
    doc.setFont("helvetica", "bold");
    doc.text("NOTAS", margin, y);
    doc.setFont("helvetica", "normal");
    y += 14;
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    const wrap = doc.splitTextToSize(o.notes, W - 2 * margin);
    doc.text(wrap, margin, y); y += wrap.length * 14;
  }

  const verifyUrl = `${window.location.origin}/verify/${o.code}?v=${o.verification_code || ""}`;
  await drawProFooter(doc, {
    settings, doctor,
    qrUrl: verifyUrl,
    qrLabel: "Verificar petición",
    sigLabel: "Firma y sello del profesional",
    signature: o.signature,
  });

  doc.save(`peticion-${o.type}-${o.code}.pdf`);
}
